var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Base',{staticClass:"modifier",class:{'color-change': _vm.colorChange}},[(_vm.data.section.text)?_c('div',{attrs:{"id":_vm.dasherize(_vm.data.section.text)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }